module.exports = __webpack_public_path__ + "static/media/Show.5dadb334.svg";